import { Component, Input, OnInit, inject,Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Apiv1Service } from '../../../../services/apiv1.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-formupdate',
   standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './formupdate.component.html',
  styleUrl: './formupdate.component.scss',
})
export class FormupdateComponent {
constructor( private store: Apiv1Service) {}

@Output() submitted = new EventEmitter<void>();
@Input() config!: FormUpdateConfig;
//@Input() idField = "Id";
@Input() id_field : string = "Id";



  form!: FormGroup;

  private fb = inject(FormBuilder);



  ngOnInit() {

    console.log("Var [this.id_field] "+ JSON.stringify(this.id_field));

    const group: any = {};
    // Create form controls dynamically
    this.config.fields.forEach(f => {
      console.log("Var [f.store_key] "+ JSON.stringify(f.store_key));

      if (f.store_key !== this.id_field)
      {
        console.log("add Var [f.store_key] "+ JSON.stringify(f.store_key));

        group[f.store_key] = [f.value];
      }
      else {
        console.log("Not add Var [f.store_key] "+ JSON.stringify(f.store_key));

      }
    });
console.log("before constructing form.");
    this.form = this.fb.group(group);
    /*
    this.config.fields.forEach(f => {
      if (f.store_key === this.id_field)
      {
        this.form.patchValue({ id_field: f.value });
      }
    
    });
    */

    console.log("ngOnInit: end.");

  }

loading = false;


  submit() {

  if (this.form.invalid) return;

  this.loading = true;

console.log("Var [this.form.value] "+ JSON.stringify(this.form.value));
var postval = this.form.value;

this.config.fields.forEach(f => {
      if (f.store_key === this.id_field)
      {
        postval[this.id_field] = f.value;
      }
    
    });
 
console.log("Var [postval] "+ JSON.stringify(postval));


  this.store.updateForPath(this.config.putPath, postval)
    .pipe(finalize(() => this.loading = false))   // <- always executed
    .subscribe({
      next: (result) => {
        console.log('Submitted:', result);
        this.submitted.emit(); // notify parent
      },
      error: (err) => {
        console.error("Error submitting form:", err);
      }
    });
  }
}
export enum InputType {
  text     = "text",
  textarea = "textarea",
  select   = "select"
}
export  interface RowDef {
  title: string;
  source: string;
}
export interface FormUpdateField {
    label: string;
    placeholder?: string;
    hint?: string;
    store_key: string;
    value?: string;
    type?:InputType;
    options?: Array<SelectOption>
  };
export interface FormUpdateConfig {
  title: string;
  buttonLabel: string;
  putPath: string;
  fields: Array<FormUpdateField>;
}
export interface SelectOption {
    value: string;
    label: string;
}